import { ClipboardList, MessagesSquare, Workflow } from 'lucide-react';
import { cross, keyFamily } from '@/lib/keyFamily';

/*
 * How the consultants work through the rules with a team: Inform, Plan,
 * Implement. The Consulting page draws them as its path
 * (Consulting/EngagementPath) and Home's consulting band lists them
 * (Welcome/Consulting), so they live here, outside both pages' folders: one
 * page's section module imported into another page would pull it into that
 * page's chunks. Their copy is `site.consulting.path.<stage>.title` and
 * `.text` (STAGE_COPY).
 */

/** The three stages, in order; each verb is its own label. */
export const STAGES = Object.freeze(['inform', 'plan', 'implement']);

/** Each stage's icon. */
export const ICONS = Object.freeze({ inform: MessagesSquare, plan: ClipboardList, implement: Workflow });

/** Each stage's title and text. */
export const STAGE_COPY = keyFamily('site.consulting.path.{0}.{1}', cross(STAGES, ['title', 'text']));
